import { render, staticRenderFns } from "./SubscriptionStatus.vue?vue&type=template&id=0a063220&scoped=true&"
import script from "./SubscriptionStatus.vue?vue&type=script&lang=js&"
export * from "./SubscriptionStatus.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionStatus.vue?vue&type=style&index=0&id=0a063220&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a063220",
  null
  
)

export default component.exports